<template>
  <div class="feed-header flex">
    <div @click="navigateToUserCenter">
      <UserAvatar
        :src="feed.userInfo.thumbHeadImg || feed.userInfo.headImgUrl"
        :userType="initType"
      />
    </div>
    <div class="feed-info flex">
      <div class="name-wrapper">
        <p class="user-name" @click="navigateToUserCenter">
          {{ feed.userInfoExtend || feed.username || feed.userInfo.name }}
        </p>
        <p class="create-time">{{ date }}</p>
      </div>
      <div class="header-action-wrapper" v-if="showAction">
        <el-button class="follow" v-if="addFollowBtn" @click="addFollow">
          <i class="el-icon-plus"></i>关注
        </el-button>
        <span v-show="addFollowProceed">
          <i class="el-icon-loading" style="font-size: 16px"></i>处理中
        </span>
        <el-dropdown
          placement="bottom"
          trigger="click"
          @command="handleAcation"
        >
          <span class="arrow-down-wrapper">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="notMine" :command="1"
              >举报</el-dropdown-item
            >
            <el-dropdown-item v-if="unFollowBtn" :command="2"
              >取消关注</el-dropdown-item
            >
            <el-dropdown-item
              v-if="!notMine && headScene == 'community'"
              :command="3"
              >撤回社区分享</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="repot-form-wrapper">
      <el-dialog
        title="举报"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        custom-class="handlian-report-container"
        width="540px"
      >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="举报原因" prop="reasonId">
            <el-radio-group v-model="ruleForm.reasonId">
              <el-radio
                v-for="(item, index) in reasonList"
                :key="index"
                :label="item.id"
                >{{ item.reason }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="其他原因" prop="reason">
            <el-input
              type="textarea"
              v-model="ruleForm.reason"
              resize="none"
              maxlength="100"
              show-word-limit
              :autosize="{ minRows: 2 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact">
            <el-input
              type="text"
              v-model="ruleForm.contact"
              placeholder="请留下您的手机号 或 传联号"
            ></el-input>
          </el-form-item>
          <p class="report-tip">请放心，你的隐私将会得到保护。</p>
          <el-form-item>
            <el-button
              class="handlian-btn"
              type="primary"
              @click="submitForm('ruleForm')"
              >立即举报</el-button
            >
            <el-button class="handlian-btn" @click="resetForm('ruleForm')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getFullDate } from "../../utils/date";
import { authorType } from "../../utils/feed";
import UserAvatar from "../../components/UserAvatar";
import { apiMap } from "../../utils/apiMap";
let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
export default {
  name: "feed-header",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    headScene: String,
  },
  data() {
    var validateContact = (rule, value, callback) => {
      var numberRegExp = /^[0-9]+$/;
      if (value !== "") {
        if (!numberRegExp.test(value)) {
          callback(new Error("联系方式只能是数字"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      addFollowBtn: false,
      unFollowBtn: false,
      showAction: false,
      addFollowProceed: false,
      notMine: true,
      initType: 1,
      dialogVisible: false,
      clearDialog: true,
      reasonList: [],
      ruleForm: {
        reasonId: "",
        reason: "",
        contact: "",
      },
      rules: {
        reasonId: [
          { required: true, message: "请选择举报原因", trigger: "change" },
        ],
        reason: [{ required: false, trigger: "blur" }],
        contact: [{ validator: validateContact, trigger: "blur" }],
      },
    };
  },
  mounted() {
    if (this.feed.userType == 1) {
      this.showAction = true;
      if (
        this.headScene == "community" &&
        this.feed.userId !== this.user.userId
      ) {
        if (this.feed.subscribe == 1) {
          this.addFollowBtn = false;
          this.unFollowBtn = true;
        } else {
          this.addFollowBtn = true;
          this.unFollowBtn = false;
        }
        this.notMine = true;
      } else {
        this.notMine = false;
        this.addFollowBtn = false;
      }
    } else {
      this.showAction = false;
    }
    if (this.feed.hasOwnProperty("userType")) {
      this.initType = this.feed.userType;
    }
  },
  components: {
    UserAvatar,
  },
  computed: {
    ...mapGetters(["user"]),
    date() {
      return getFullDate(new Date(this.feed.created_at * 1000));
    },
  },
  watch: {
    feed: {
      handler(newValue) {
        if (newValue.subscribe == 1) {
          this.addFollowBtn = false;
          this.unFollowBtn = true;
        } else {
          this.addFollowBtn = true;
          this.unFollowBtn = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.reportThisFeed(this.ruleForm);
          this.dialogVisible = false;
          this.resetForm("ruleForm");
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.resetForm("ruleForm");
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleAcation(action) {
      switch (action) {
        case 1:
          //举报
          if (this.headScene == "community") {
            this.getReportOption((result) => {
              if (result.statusCode == 1) {
                this.reasonList = result.data;
                this.dialogVisible = true;
              } else {
                this.$message({
                  message: "获取举报原因失败，暂不能举报",
                  duration: 1500,
                  offset: 230,
                });
              }
            });
          } else {
            this.$message({
              message: "请先登录",
              duration: 1500,
              offset: 230,
            });
          }
          break;
        case 2:
          //取消关注
          let tipText = `确定不再关注 “ ${
            this.feed.userInfoExtend || this.feed.username
          } ” ？`;
          this.$confirm(tipText, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
            closeOnClickModal: false,
          })
            .then(() => {
              this.switchFollow(() => {
                // this.addFollowBtn = true;
                // this.unFollowBtn = false
                this.$bus.$emit("update-follow-status", {
                  userID: this.feed.userId,
                  feedID: this.feed.modelId,
                  status: 0,
                });
              });
            })
            .catch(() => {});

          break;

        case 3:
          //撤回分享
          this.$confirm("确定撤回分享吗？", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
            closeOnClickModal: false,
          })
            .then(() => {
              this.$bus.$emit(
                "unshare-community-feed",
                this.feed.modelId,
                this.feed.article
              );
            })
            .catch(() => {});
          break;
      }
    },
    addFollow() {
      if (this.headScene == "community") {
        if (this.feed.userId !== this.user.userId) {
          this.addFollowProceed = true;
          this.switchFollow(() => {
            this.$bus.$emit("update-follow-status", {
              userID: this.feed.userId,
              feedID: this.feed.modelId,
              status: 1,
            });
            setTimeout(() => {
              this.addFollowProceed = false;
            }, 1000);
          });
        } else {
          this.$message({
            message: "您不能关注自己哦",
            duration: 1500,
            offset: 230,
          });
        }
      } else {
        this.$message({
          message: "请先登录",
          duration: 1500,
          offset: 230,
        });
      }
    },
    switchFollow(cb) {
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["switchFollow"]["method"],
          url: apiMap["switchFollow"]["url"],
          data: `token=${loginUser.token}&followerId=${this.feed.userId}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            $this.$message({
              message: "操作成功！",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            cb(response.data.result.statusCode);
          } else {
            $this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    unShareThisFeed(cb) {
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["switchFollow"]["method"],
          url: apiMap["switchFollow"]["url"],
          data: `token=${loginUser.token}&followerId=${this.feed.userId}`,
        })
        .then(function (response) {
          cb(response.data.result.statusCode);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reportThisFeed(fromData) {
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["reportFeed"]["method"],
          url: apiMap["reportFeed"]["url"],
          data: `token=${loginUser.token}&modelId=${this.feed.modelId}&modelType=${this.feed.article}&reasonId=${fromData.reasonId}&contact=${fromData.contact}&reason=${fromData.reason}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            $this.$message({
              message: "操作成功！",
              type: "success",
              duration: 1500,
              offset: 230,
            });
          } else {
            $this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getReportOption(cb) {
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["reportReasons"]["method"],
        url: apiMap["reportReasons"]["url"],
        params: {
          token: loginUser.token,
        },
      })
        .then(function (response) {
          cb(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    navigateToUserCenter() {
      if (this.feed.userType == 1) {
        if (this.feed.userId) {
          this.$router.push({
            path: "/feed",
            query: {
              id: this.feed.userId,
            },
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.feed-info {
  width: 91%;
  justify-content: space-between;
}

.name-wrapper {
  margin-left: 6px;
  line-height: 20px;
}

.name-wrapper .user-name {
  font-size: 16px;
  line-height: 30px;
}

.name-wrapper .create-time {
  color: #999;
}

.arrow-down-wrapper {
  width: 45px;
  height: 25px;
  display: inline-block;
  text-align: center;
  font-size: 17px;
  cursor: pointer;
}

.arrow-down-wrapper:hover {
  color: #ff6600;
}

.follow {
  padding: 4px 5px;
}

.report-tip {
  margin-left: 100px;
  margin-bottom: 10px;
}
</style>